



































































import Vue from 'vue'

declare interface Language {
  text: string,
  value: string,
}

export type DataType = {
  languages: Language[],
}

export default Vue.extend({
  name: 'Footer',

  data(): DataType {
    return {
      languages: [
        {
          text: 'čeština',
          value: 'cs',
        },
        {
          text: 'English',
          value: 'en',
        },
        {
          text: '日本語',
          value: 'ja',
        }
      ],        
    }
  },

  computed: {
    currentLanguage(): string {
      return this.languages.find((language: Language) => language.value === this.$i18n.locale)!.text
    }
  },

  methods: {
    switchLanguage(language: string) {
      this.$i18n.locale = language
      localStorage.setItem('language', language)
    }
  }
})
